'use client'

import CookieSettingsLink from './CookieSettingsLink'

// Minimal in-flow legal line at the foot of every page. Required by GDPR:
// "Cookie settings" must be reachable from every page. The site has no
// dedicated Footer component yet — this is a placeholder to satisfy the
// requirement; restyle/relocate once a real footer lands.
export default function SiteLegalRow() {
  const year = new Date().getFullYear()
  return (
    <div
      className="site-legal-row"
      style={{
        display: 'flex',
        gap: 'var(--space-md)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 'var(--space-xl) var(--space-lg)',
        fontSize: 'var(--fs-caption)',
        letterSpacing: 'var(--ls-caption)',
        color: 'rgba(241, 233, 207, 0.7)',
        background: 'var(--surface-5-deep)',
        textTransform: 'uppercase',
      }}
    >
      <span>© {year} BioSoil</span>
      <span aria-hidden>·</span>
      <CookieSettingsLink
        className="site-legal-row__link"
      />
    </div>
  )
}
